import React, { createContext, FC, useContext, useMemo } from 'react';
import BiLoggerFactory, { type Logger } from '@wix/fe-essentials-standalone/bi';

export interface IBiContext {
  logger: Logger;
}

export const BiContext = createContext<IBiContext>({
  logger: null as unknown as Logger,
});

export const BiContextProvider: FC = ({ children }) => {
  const logger = useMemo(() => BiLoggerFactory.factory().logger(), []);

  return <BiContext.Provider value={{ logger }}>{children}</BiContext.Provider>;
};

export const useBiLogger = () => useContext(BiContext);
